<template>
  <b-container fluid class="px-0">
    <b-form-group
      label="Filter"
      label-for="filter-input"
      class="col-12"
    >
      <b-input-group size="sm">
        <b-form-input
          id="filter-input"
          v-model="filter"
          type="search"
          placeholder="Type to Search"
        ></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-table  class="col-12 table-responsive" :items="equipmentSections" :fields="fields" :filter="filter"  >
      <template #cell(perimeter)="row">
        {{row.value | round}} M
      </template>
      <template #cell(area)="row">
        {{row.value | round}} <span v-if="row.value">M<sup>2</sup></span>
      </template>
      <template #cell(label)="row">
        <span style="cursor:pointer"
          v-b-tooltip.hover.right="'click to locate'"
          @click="locateEquipment(row.item.id)"
        >
        {{ row.item.label || "No Label" }} <font-awesome-icon color="royalblue"  icon="search" />
        <br/>
        <small class="text-info">{{$t("equipment_type." + ((row.item.equipment_detail || {}).equipment_config || {}).name)}} ({{ row.item.shape_type }})</small>
        x
        </span>
      </template>
      <template #cell(icon)="row">
        <img :src="equipmentIcon(((row.item.equipment_detail || {}).equipment_config || {}).icon)" width="25"/>
      </template>
      <template #cell(action)="row">
        <div>
          <a href="javascript://" @click="editSection(row.item.id)">
            <font-awesome-icon icon="pencil" size="sm" class="mr-2 text-dark" />
          </a>
          <a href="javascript://" @click="deleteSection(row.item)">
            <font-awesome-icon icon="trash" size="sm" class="text-danger"/>
          </a>
        </div>
      </template>
    </b-table>
  </b-container>


</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
      name: "EquipmentsListDrawer",
      data: () => ({
        filter: null
      }),

      computed: {
        ...mapGetters({
          sections: 'sections/items'
        }),

        equipmentSections: function(){
          return this.sections.filter(s => s.section_type == 'equipment')
        },

        fields(){
          return [
            { key: 'icon', label: this.$t("sidebar.heading.icon"), sortable: false },
            { key: 'label', label: this.$t("sidebar.heading.equipment"), sortable: true },
            { key: 'perimeter', label: this.$t("sidebar.heading.perimeter"), sortable: true },
            { key: 'area', label: this.$t("sidebar.heading.area"), sortable: true },
            { key: 'action', label: this.$t("sidebar.heading.action"), sortable: false },
          ]
        },

      },

      methods: {
        equipmentIcon(icon){
          return require(`@/assets/equipment_icons/${icon}`);
        },

        editSection(sectionId){
          this.$store.dispatch('sections/selectItem', sectionId)
          this.$store.dispatch('ui/projectSidebar.open', {
            show: true,
            component: 'SectionInfoDrawer',
            heading: 'Equipment detail',
            align: 'right',
            right: true,
            width: '300px',
            noHeader: true,
            key: `section-${sectionId}`
          })
        },

        deleteSection(section){
          if(confirm("Are you sure to delete Equipment?")){
            this.$store.dispatch("sections/delete", {
              projectId: section.project_id,
              id: section.id
            })
          }
        },

        locateEquipment(equipmentId){
          if(this.$store.getters['projects/item'].asset_type == 'drone'){
            this.editSection(equipmentId)
          } else {
            this.$eventbus.$emit('locate', equipmentId)
          }
        }
      }
  }
</script>
